module.exports = __webpack_public_path__ + "static/media/box_apple.f94f0468.svg";